import update from 'immutability-helper';
import moment from 'moment-timezone';
import _orderBy from 'lodash/orderBy';
import _uniqBy from 'lodash/unionBy';
import * as enums from './enums';

const InventoryUtils = {
    setInventory(property, value, props) {
        let parts = property.split('.');
        let actualInventory = Object.assign({}, props.model.inventory.inventory);

        if (parts.length === 2) {
            actualInventory = update(actualInventory, {
                [parts[0]]: {
                    [parts[1]]: {
                        $set: value
                    }
                }
            });
        } else {
            actualInventory = update(actualInventory, {
                [property]: {
                    $set: value
                }
            });
        }

        let inventory = Object.assign({}, props.model.inventory, {
            inventory: actualInventory
        });

        this.propertyChanged('inventory', inventory, props);
    },

    configurationOptionChange(property, value) {
        InventoryUtils.setInventory(property, value, this.props);
    },

    propertyChanged(property, value, props) {
        if (!props.readOnly) {
            let inventory = null;
            if (property.indexOf('.') === -1) {
                inventory = update(props.model, {
                    [property]: {
                        $set: value
                    }
                });
            } else {
                let parts = property.split('.');
                if (parts.length === 2)
                    inventory = update(props.model, {
                        inventoryData: {
                            $set: value
                        }
                    });
                else if (parts.length === 3) {
                    inventory = update(props.model, {
                        [parts[0]]: {
                            [parts[1]]: {
                                [parts[2]]: {
                                    $set: value
                                }
                            }
                        }
                    });
                }
            }

            props.actions.setInventory(inventory);
        }
    },

    dayDateChanged(props, ev) {
        let inventoryCurrent = Object.assign({}, props.model.inventory.inventory, {
            from: ev.startDate.toISOString(),
            to: ev.endDate.toISOString()
        });

        let inventory = Object.assign({}, props.model.inventory, {
            inventory: inventoryCurrent
        });

        InventoryUtils.propertyChanged('inventory', inventory, props);
    },

    dayChanged(props, days) {
        console.log(days);
        let inventoryCurrent = Object.assign({}, props.model.inventory.inventory);
        inventoryCurrent.days = days;

        let inventory = Object.assign({}, props.model.inventory, {
            inventory: inventoryCurrent
        });

        InventoryUtils.propertyChanged('inventory', inventory, props);
    },

    getRoomCategoriesFromHotel(hotel) {
        let roomCategoryOptions = [];

        if (hotel && Array.isArray(hotel.roomCategories)) {
            roomCategoryOptions = hotel.roomCategories.map((x) => {
                return { label: x.name, value: x.id };
            });
        }
        return roomCategoryOptions;
    },

    getRoomTypesFromHotel(hotel, roomCategory, defaultRTvalues) {
        let category = roomCategory
            ? hotel.roomCategories.find((x) => x.id == roomCategory.value).roomTypes
            : hotel.roomCategories[0].roomTypes;

        let unorderedData = _uniqBy(
            category.map((x) => {
                return {
                    name: x.name,
                    nameLower: x.name.toLowerCase(),
                    id: x.id,
                    allotment: x.allotment == 0 ? defaultRTvalues.allotment[x.name] : 0
                };
            }),
            'name'
        );

        return this.getRoomTypesSorted(unorderedData, category);
    },

    getRoomTypesSorted(roomTypesOptions, rooms) {
        let roomTypeOrdered = [];
        if (typeof roomTypesOptions != 'undefined') {
            roomTypesOptions
                .filter((roomType) => {
                    const hotelRoom = rooms.find((element) => element.name === roomType.name);
                    return hotelRoom && hotelRoom.status;
                })
                .map((x) => {
                    switch (x.name) {
                        case 'Single':
                            roomTypeOrdered.push({
                                name: x.name,
                                id: x.id,
                                allotment: x.allotment,
                                availableAllotment:
                                    typeof x.availableAllotment !== 'undefined' ? x.availableAllotment : x.allotment,
                                order: 5
                            });
                            break;
                        case 'Double':
                            roomTypeOrdered.push({
                                name: x.name,
                                id: x.id,
                                allotment: x.allotment,
                                availableAllotment:
                                    typeof x.availableAllotment !== 'undefined' ? x.availableAllotment : x.allotment,
                                order: 1
                            });
                            break;
                        case 'Double for Single Use':
                            roomTypeOrdered.push({
                                name: x.name,
                                id: x.id,
                                allotment: x.allotment,
                                availableAllotment:
                                    typeof x.availableAllotment !== 'undefined' ? x.availableAllotment : x.allotment,
                                order: 6
                            });
                            break;
                        case 'Twin':
                            roomTypeOrdered.push({
                                name: x.name,
                                id: x.id,
                                allotment: x.allotment,
                                availableAllotment:
                                    typeof x.availableAllotment !== 'undefined' ? x.availableAllotment : x.allotment,
                                order: 2
                            });
                            break;
                        case 'Twin for Single Use':
                            roomTypeOrdered.push({
                                name: x.name,
                                id: x.id,
                                allotment: x.allotment,
                                availableAllotment:
                                    typeof x.availableAllotment !== 'undefined' ? x.availableAllotment : x.allotment,
                                order: 7
                            });
                            break;
                        case 'Triple':
                            roomTypeOrdered.push({
                                name: x.name,
                                id: x.id,
                                allotment: x.allotment,
                                availableAllotment:
                                    typeof x.availableAllotment !== 'undefined' ? x.availableAllotment : x.allotment,
                                order: 3
                            });
                            break;

                        case 'Quad':
                            roomTypeOrdered.push({
                                name: x.name,
                                id: x.id,
                                allotment: x.allotment,
                                availableAllotment:
                                    typeof x.availableAllotment !== 'undefined' ? x.availableAllotment : x.allotment,
                                order: 4
                            });
                            break;
                        default:
                            roomTypeOrdered.push({
                                name: x.name,
                                id: x.id,
                                allotment: x.allotment,
                                availableAllotment:
                                    typeof x.availableAllotment !== 'undefined' ? x.availableAllotment : x.allotment,
                                order: 8
                            });
                            break;
                    }
                });
        }
        return _orderBy(_uniqBy(roomTypeOrdered, 'name'), [ 'order' ]);
    },

    resetPageOnAdd(isHotel, props) {
        let inventoryObject = update(props.model, {
            ...this.resetVars(isHotel),
            editIndex: { $set: -1 }
        });

        props.actions.resetPageOnAdd(inventoryObject);

        return inventoryObject;
    },

    resetVars(isHotel) {
        let fromTo = moment.tz().toISOString();

        let partReset = {
            allocation: {
                count: { $set: 0 },
                releaseDays: { $set: 0 },
                status: { $set: 3 }
            },
            freesale: {
                count: { $set: 0 },
                releaseDays: { $set: 0 },
                status: { $set: 3 }
            },
            days: { $set: '' },
            date: {
                from: { $set: fromTo },
                to: { $set: fromTo }
            }
        };

        let fullReset = {
            roomCategory: { $set: '' },
            roomType: {
                Single: { $set: 10 },
                Double: { $set: 10 },
                Twin: { $set: 10 },
                Triple: { $set: 0 },
                Quad: { $set: 0 },
                Familiy: { $set: 0 },
                Dormitory: { $set: 0 }
            },
            from: { $set: fromTo },
            to: { $set: fromTo }
        };

        return isHotel ? fullReset : partReset;
    },

    excludeInventoryRowId(inventory) {
        let inventoryExcluded = Object.assign({}, inventory);
        delete inventoryExcluded.rowId;

        return inventoryExcluded;
    },

    checkReleaseDayIsValid(inventory) {
        let now = moment.tz().format('YYYY-MM-DD');
        let endDate = moment.tz(inventory.to, 'Europe/London').format('YYYY-MM-DD');
        let dateToInvaldateAllocation = moment
            .tz(inventory.to, 'Europe/London')
            .subtract(inventory.allocation.releaseDays, 'days')
            .format('YYYY-MM-DD');

        if (now >= endDate) {
            return enums.CLOSED;
        } else if (now >= dateToInvaldateAllocation && now <= endDate) {
            return enums.EXPIRING;
        }

        return enums.OPEN;
    },

    checkReleaseDayIsValidTest(now, inventory) {
        let endDate = moment.tz(inventory.to, 'Europe/London').format('YYYY-MM-DD');
        let dateToInvaldateAllocation = moment
            .tz(inventory.to, 'Europe/London')
            .subtract(inventory.allocation.releaseDays, 'days')
            .format('YYYY-MM-DD');

        if (now >= endDate) {
            return enums.CLOSED;
        } else if (now >= dateToInvaldateAllocation && now <= endDate) {
            return enums.EXPIRING;
        }

        return enums.OPEN;
    },

    filterData(inventorySearchData, props) {
        let inventoryDataFiltered = [];

        if (inventorySearchData && inventorySearchData.length > 0) {
            inventorySearchData.map((element) => {
                inventoryDataFiltered.push(element);
            });
        }
        return inventoryDataFiltered;
    },

    rowSelected(index, props) {
        let pageObject = Object.assign({}, this.props.model, {
            inventory: props.model.inventoryData[index].inventory,
            editIndex: index
        });

        props.onRoomTypeMaxAllocationChange(pageObject.inventoryData[0].inventory.roomType);
        InventoryUtils.propertyChanged('inventory', pageObject, props);
    },

    mergeObjects(stored, newObj) {
        var reduced = stored.filter((sitem) => {
            return !newObj.find((nitem) => {
                return moment.tz(sitem['dateOfAllocation'], 'Europe/London').isSame(nitem['dateOfAllocation'], 'day');
            });
        });
        return reduced.concat(newObj);
    }
};

export default InventoryUtils;
